module.exports = __webpack_public_path__ + "img/P150T_weapon_55.cd03e6b8.png";